@if (getVisibleGroups(groups()); as visibleGroups) {
	<article class="collapsible-groups" [ngClass]="{ 'mulitple-groups': visibleGroups.length > 1 }">
		@if (showTranslateNone(visibleGroups) && translateNone) {
			<p class="empty" translate="{{ translateNone }}"></p>
		}
		@if (visibleGroups.length > 1 || singleGroupCollapsible()) {
			<ul class="grouped-list">
				@for (group of visibleGroups; track trackBy($index, group); let last = $last) {
					<li class="group" [ngClass]="{ last: last }">
						<header class="group-header" [ngClass]="{ hover: hoverOnHeader() }" (click)="toggle(group)">
							<ng-container
								[ngTemplateOutlet]="groupHeaderTemplate() ?? defaultGroupHeader"
								[ngTemplateOutletContext]="{ $implicit: group }"
							>
							</ng-container>
							<stages-button-expand-collapse
								[isCollapsed]="!isGroupOpen(group)"
								[classes]="!isEmbeddedInDialog() ? 'action menu-button' : 'menu-button'"
							></stages-button-expand-collapse>
							@if (!!groupHeaderActionMenuTemplate) {
								<ng-container
									[ngTemplateOutlet]="groupHeaderActionMenuTemplate"
									[ngTemplateOutletContext]="{ $implicit: group }"
								></ng-container>
							}
						</header>
						<div class="relative-container">
							<div class="animation-container">
								<div
									#expandableGroup
									[@expandCollapseFromTop]="getExpandCollapseFromTop(group, expandableGroup)"
									class="expandable"
									[ngClass]="isGroupOpen(group) ? 'expand' : 'collapse'"
								>
									<ng-container
										[ngTemplateOutlet]="groupContentTemplate()"
										[ngTemplateOutletContext]="{ $implicit: group }"
									>
									</ng-container>
								</div>
							</div>
						</div>
					</li>
				}
			</ul>
		}
		@if (visibleGroups.length == 1 && !singleGroupCollapsible()) {
			<ul class="grouped-list">
				<ng-container
					[ngTemplateOutlet]="groupContentTemplate()"
					[ngTemplateOutletContext]="{ $implicit: visibleGroups[0] }"
				>
				</ng-container>
			</ul>
		}
	</article>
}

<ng-template #defaultGroupHeader let-group>
	<h3>
		{{ group.name ? group.name : (group.nameKey! | translate)
		}}<span class="counter">{{ group.getMemberCount() }}</span>
	</h3>
</ng-template>
